<template>
  <IconLucideMaximize />
</template>
